export const getUserIds = (users) => {
    const filtered = {};
    users.forEach((user) => {
        filtered[user.id] = user?.firstName || user.handle || '?';
    });
    return filtered;
};
